<template>
  <div class="api-page">
    <div class="banner">
      <div class="banner-content">
        <h1 class="title">常用工具</h1>
        <p class="subtitle">丰富好用的常用工具</p>
      </div>
    </div>
    <div class="container">
      <div class="tools-category">
        <h2 class="category-title" @click="isDevToolsVisible = !isDevToolsVisible">开发工具</h2>
        <div v-if="isDevToolsVisible" class="tools-grid">
          <!-- 开发工具 -->
          <el-card v-for="tool in devTools"
                   :key="tool.id"
                   class="tool-card"
                   @click="handleToolClick(tool)">
            <template #header>
              <div class="card-header">
                <h3>{{ tool.name }}</h3>
              </div>
            </template>
            <div class="tool-content">
              <p>{{ tool.description }}</p>
            </div>
          </el-card>
        </div>
      </div>
      <div class="tools-category">
        <h2 class="category-title" @click="isDataToolsVisible = !isDataToolsVisible">数据处理</h2>
        <div v-if="isDataToolsVisible" class="tools-grid">
          <!-- 数据处理工具 -->
          <el-card v-for="tool in dataTools"
                   :key="tool.id"
                   class="tool-card"
                   @click="handleToolClick(tool)">
            <template #header>
              <div class="card-header">
                <h3>{{ tool.name }}</h3>
              </div>
            </template>
            <div class="tool-content">
              <p>{{ tool.description }}</p>
            </div>
          </el-card>
        </div>
      </div>
      <div class="tools-category">
        <h2 class="category-title" @click="isCalculateToolsVisible = !isCalculateToolsVisible">计算工具</h2>
        <div v-if="isCalculateToolsVisible" class="tools-grid">
          <!-- 数据处理工具 -->
          <el-card v-for="tool in calculate"
                   :key="tool.id"
                   class="tool-card"
                   @click="handleToolClick(tool)">
            <template #header>
              <div class="card-header">
                <h3>{{ tool.name }}</h3>
              </div>
            </template>
            <div class="tool-content">
              <p>{{ tool.description }}</p>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const isDataToolsVisible = ref(true) // 控制数据处理工具的可见性
const isDevToolsVisible = ref(true) // 控制开发工具的可见性
const isCalculateToolsVisible = ref(true) // 控制计算工具的可见性

const dataTools = ref([
  {
    id: 1,
    name: '在线JSON格式化',
    description: '格式化和验证JSON数据',
    path: '/tools/json'
  },
  {
    id: 2,
    name: '时间戳转换',
    description: '时间戳与日期时间互转',
    path: '/tools/timestamp'
  },
  {
    id: 3,
    name: 'Base64编解码',
    description: '文本与Base64互相转换',
    path: '/tools/base64'
  },
  {
    id: 4,
    name: 'URL编解码',
    description: 'URL编码与解码工具',
    path: '/tools/url'
  },
  {
    id: 5,
    name: 'MD5加密',
    description: '字符串MD5加密工具',
    path: '/tools/md5'
  },
  {
    id: 6,
    name: '二维码生成',
    description: '生成自定义二维码',
    path: '/tools/qrcode'
  },
  {
    id: 7,
    name: '颜色转换',
    description: 'RGB、HEX等颜色格式转换',
    path: '/tools/color'
  },

  {
    id: 9,
    name: '图片压缩',
    description: '在线压缩图片文件',
    path: '/tools/image-compress'
  },
  {
    id: 13,
    name: '字数统计',
    description: '文本字数、字符数统计',
    path: '/tools/word-count'
  },
  {
    id: 15,
    name: '密码生成器',
    description: '生成随机安全密码',
    path: '/tools/password-gen'
  },{
    id: 17,
    name: '拼音转换',
    description: '汉字转拼音工具',
    path: '/tools/pinyin'
  }, {
    id: 18,
    name: '文本比较',
    description: '对比两段文本的差异',
    path: '/tools/text-diff'
  }
])

const calculate = ref([

  {
    id: 21,
    name: '随机数生成',
    description: '生成指定范围随机数',
    path: '/tools/random-number'
  },
  {
    id: 22,
    name: 'BMI计算器',
    description: '身体质量指数计算',
    path: '/tools/bmi'
  },
  {
    id: 23,
    name: '重量换算',
    description: '各种重量单位间转换',
    path: '/tools/weight-converter'
  },
  {
    id: 24,
    name: '体积换算',
    description: '各种体积单位间转换',
    path: '/tools/volume-converter'
  },
  {
    id: 25,
    name: '时间换算',
    description: '各种时间单位间转换',
    path: '/tools/time-converter'
  },
  {
    id: 26,
    name: '存储换算',
    description: '数据存储单位间转换',
    path: '/tools/storage-converter'
  },
  {
    id: 27,
    name: '速度换算',
    description: '各种速度单位间转换',
    path: '/tools/speed-converter'
  },
  {
    id: 28,
    name: '压力换算',
    description: '各种压力单位间转换',
    path: '/tools/pressure-converter'
  },
  {
    id: 29,
    name: '长度换算',
    description: '各种长度单位间转换',
    path: '/tools/length-converter'
  },
  {
    id: 30,
    name: '力换算',
    description: '各种力单位间转换',
    path: '/tools/force-converter'
  },
  {
    id: 31,
    name: '密度换算',
    description: '各种密度单位间转换',
    path: '/tools/density-converter'
  },
  {
    id: 32,
    name: '面积换算',
    description: '各种面积单位间转换',
    path: '/tools/area-converter'
  },
  {
    id: 33,
    name: '功率换算',
    description: '各种功率单位间转换',
    path: '/tools/power-converter'
  },
  {
    id: 34,
    name: '温度换算',
    description: '各种温度单位间转换',
    path: '/tools/temperature-converter'
  },
  {
    id: 35,
    name: '亲戚称谓计算器',
    description: '计算亲戚关系称谓',
    path: '/tools/relationship-calculator'
  }
])
const devTools = ref([
  // 开发工具
  {
    id: 8,
    name: '正则测试',
    description: '正则表达式在线测试',
    path: '/tools/regex'
  },
  {
    id: 20,
    name: 'Cron表达式',
    description: 'Cron表达式生成与测试',
    path: '/tools/cron'
  },
  {
    id: 12,
    name: 'JavaScript美化',
    description: 'JS代码格式化和压缩',
    path: '/tools/js-beautify'
  },

  {
    id: 14,
    name: '进制转换',
    description: '进制数值转换工具',
    path: '/tools/base-converter'
  },
  {
    id: 16,
    name: 'UUID生成器',
    description: '生成UUID/GUID',
    path: '/tools/uuid-gen'
  }
])

const handleToolClick = (tool) => {
  router.push(tool.path)
}
</script>

<style scoped>
.api-page {
  min-height: 100vh;
}
.banner {
  height: 300px; /* 增加高度 */
  background-image: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url('https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center;
  margin-top: -60px;
}

.banner-content {
  text-align: center;
  color: white;
  padding-top: 60px; /* 添加顶部内边距，抵消导航栏的高度 */
}
.tools-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  margin-top: 80px;
}
.title {
  font-size: 48px;
  margin: 10px 0; /* 调整上下间距 */
   padding-top: 30px;
  font-weight: 600; /* 加粗标题 */
}

.subtitle {
  font-size: 24px;
  opacity: 0.9; /* 稍微降低透明度 */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}
.tools-category {
  margin-bottom: 50px; /* 增加类别之间的间距 */
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); /* 修改为自适应布局 */
  gap: 20px;
  margin-top: 30px;
}

.tool-card {
  cursor: pointer;
  transition: transform 0.2s;
}

.tool-card:hover {
  transform: translateY(-5px);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tool-content {
  color: #666;
}

.category-title {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
  cursor: pointer;
  transition: color 0.3s;
}

.category-title:hover {
  color: #409EFF;
}
</style>
